import React, { Component } from "react";
import moment from "moment";
import { initiateCheckout } from "foree-checkout";

import { constants } from "../../Constants";
import { maxLengthCheck, isPhoneNumber } from "../../helpers/utils";
import { foreeCheckoutStatus, foreeApiKey } from "../../config";
import "./ForeeModal.css";

export default class ForeeModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      foreeError: "",
      phoneNumber: "",
      foreeCheckoutSuccess: false,
    };
  }

  componentDidMount() {
    this.props.contactNumber && this.props.contactNumber.length > 10
      ? this.setState({
          phoneNumber: this.props.contactNumber,
        })
      : null;
  }

  callBackFn = (res) => {
    if (res.message === "Your payment could not be processed") {
      this.setState({ foreeError: res.message });
      this.props.errorPopup(res.message);
    } else {
      this.props.callAppointmentApiCall(res, this.state.phoneNumber, "foree");
    }
    this.props.setIsLoading(false);
    return;
  };

  foreeCheckout = () => {
    if (
      this.state.phoneNumber &&
      this.state.phoneNumber.length > 10 &&
      this.state.phoneNumber.length <= 15
    ) {
      this.props.setIsLoading(true);
      const data = {
        key: foreeApiKey.trim(),
        amount: this.props.counsellorDetails.price_pkr,
        customer_phone_number: Number(this.state.phoneNumber),
        create_bill: true,
        callback: this.callBackFn,
        reference_number: this.props.cryptedString, // Customer reference number
        payment_method: "card",
      };
      const res = initiateCheckout(
        data,
        foreeCheckoutStatus == "0" ? false : true
      );
      this.props.showForeeModal(false);
    } else {
      this.props.errorPopup(
        "Phone number should not be less than 10 and greater than 15 digits."
      );
    }
  };

  render() {
    return (
      <div className="foree-modal-box" onClick={this.props.showForeeModal}>
        <div
          className={`foree-modal-inner ${
            this.state.foreeError && "foree-error-border"
          }`}
          onClick={(e) => e.stopPropagation()}
        >
          <h2>Pay For Your Appointment</h2>
          <h3>Fee : PKR {this.props.counsellorDetails.price_pkr} </h3>
          <div className="text-center mt-3">
            Your chosen time is{" "}
            {moment(this.props.selected_date_time).format("LLLL")}
          </div>
          <br />
          <div className="text-center mt-3">
            <input
              type="number"
              className="form-control"
              autoComplete="off"
              id="phoneNumber"
              min="0"
              step="1"
              maxLength="15"
              inputMode="tel"
              onInput={(e) => maxLengthCheck(e)}
              onKeyDown={(e) => isPhoneNumber(e)}
              onChange={(e) => this.setState({ phoneNumber: e.target.value })}
              placeholder={"Enter phone number e.g. 03001234567"}
              value={
                this.state.phoneNumber
                  ? this.state.phoneNumber
                  : "Enter phone number e.g. 03001234567"
              }
              required
            />
          </div>
          <br />
          <button
            id="foree-btn"
            className="sh-gnrl-btn sh-login-btn"
            onClick={this.foreeCheckout}
          >
            {constants.FOREE_CHECKOUT}
          </button>
          <br />
          <div className="mt-3 text-center txt-center note-div">
              <div className="text-center txt-center">
                Note: 
              </div>
              <div className="text-left txt-left">
                Make sure your card is activated for internet banking.<br />
                Incorrect Credit Card or related details would cause an error
                here.
              </div>
          </div>
          <br />
          {this.state.foreeError ? (
            <div className="paypal-error text-center mt-3">
              <p>{this.state.foreeError}.</p>
            </div>
          ) : null}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ForeeModal/ForeeModal.js